// extracted by mini-css-extract-plugin
export default {"root":"IconPlus_root__J1pRK","isOpen":"IconPlus_isOpen__Fmerw"};